// extracted by mini-css-extract-plugin
module.exports = {"announcements":"PrivateNavAnnouncements_announcements__3_vxx"};